import React from 'react';
import CustomImage from '../../../components/custom-image';
import ContentSlider from '../../../components/content-slider';

const EnviromentRestoration = () => {
  const slider = {
    slides: [
      <div className="child-education-slider">
        <CustomImage
          className="custom-image"
          imageName="environment-restoration.jpg"
          alt="Enviroment Restoration"
          maxWidth="768"
        />
      </div>,
      <div className="child-education-slider">
        <CustomImage
          className="custom-image"
          imageName="environment-restoration2.jpg"
          alt="Enviroment Restoration"
          maxWidth="768"
        />
      </div>,
      <div className="child-education-slider">
        <CustomImage
          className="custom-image"
          imageName="environment-restoration3.jpg"
          alt="Enviroment Restoration"
          maxWidth="768"
        />
      </div>
    ],
  };
  return (
    <div className="accordion-body">
      <div className="sd-content">
          <div className="left">
            <div className="blue-box">
              <p className="feature-title"><strong>Key Features</strong></p>
              <div className="sd-column">
                <div className="left no-border">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">159,000</p>
                  <p className="feature-benifit">saplings planted and under maintenance</p>
                </div>
              </div>
              
            </div>
            <div className="bottom-content">
              <p><strong>Types of Interventions</strong></p>
              <p className="p-50">
              Sapling plantation & greenbelt management; Water conservation structures; Pond desilting
              </p>
            </div>
          </div>
          <div className="right">
            <ContentSlider
              data={slider.slides}
              customClass="blue-dots-slider"
              slidesToShow={1}
              slidesToScroll={1}
              dots={true}
            />
          </div>
      </div>
    </div>
  );
};

export default EnviromentRestoration;
